import { render } from "./CheckEmail.vue?vue&type=template&id=1afe1259&scoped=true"
import script from "./CheckEmail.vue?vue&type=script&lang=js"
export * from "./CheckEmail.vue?vue&type=script&lang=js"

import "./CheckEmail.vue?vue&type=style&index=0&id=1afe1259&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afe1259"]])

export default __exports__